















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Api from "../../api/index";
import { getCookie, getStorage } from "@szgc/plt-core-v2";

@Component({
  name: "WbenFileList",
  components: {}
})
export default class WbenFileList extends Vue {
  @Prop({
    default() {
      return [];
    }
  })
  private dataAll!: any;

  private prefix: any = "";
  private processData: any = null;
  private fileList: any[] = [];

  @Watch("dataAll", { immediate: true, deep: true })
  private getData(newVal: any) {
    if (newVal) {
      this.prefix = getCookie("plt-api-route") || getStorage("plt-api-route") || "";
      this.processData = JSON.parse(JSON.stringify(newVal));
      if (this.dataAll && this.dataAll.length && this.dataAll.length > 0) {
        this.fileList = this.dataAll;
      }
    }
  }

  downLoadFileOpt(attDownloadUrlField: any, fileName: any) {
    const a = document.createElement("a") as any;
    a.style = "display: none"; // 创建一个隐藏的a标签
    a.download = fileName;
    a.href = attDownloadUrlField;
    document.body.appendChild(a);
    a.click(); // 触发a标签的click事件
    document.body.removeChild(a);
  }

  /*下载附件*/
  downLoadFile(item: any) {
    let url: string = "";
    if (this.prefix) {
      url = `${this.prefix}/${Api.downLoadAtt}?attId=${item.attId}`;
    } else {
      url = `${window.location.origin}/${Api.downLoadAtt}?attId=${item.attId}`;
    }
    this.downLoadFileOpt(url, item.fileName);
  }
}
